module.exports = __webpack_public_path__ + "static/media/homebackground11.b8230f9b.svg";